import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { SnackbarContainer } from 'components/standalone';
import { extractErrorMessage } from 'utils';
import { BoardContainer, BoardFormValues } from '../containers';
import { BoardForm } from '../components';

const BoardCreateInner = () => {
  const classes = useStyles();
  const history = useHistory();
  const { notify } = SnackbarContainer.useContainer();
  const {
    formLoading,
    setFormLoading,
    createBoard,
    existingBoards,
    loadBoardTypesForValidation,
  } = BoardContainer.useContainer();

  useEffect(() => {
    loadBoardTypesForValidation();
  }, [loadBoardTypesForValidation]);

  const handleSubmit = useCallback(
    async (values: BoardFormValues) => {
      setFormLoading(true);
      try {
        const created = await createBoard(values);
        notify('Element created');
        history.push(`/board-type/${created.id}`);
      } catch (error: unknown) {
        console.error('Board create failed:', error);
        notify(extractErrorMessage(error, 'Failed to create board'), 'error');
      } finally {
        setFormLoading(false);
      }
    },
    [createBoard, history, notify, setFormLoading],
  );

  const handleGoBack = useCallback(() => {
    history.push('/board-type');
  }, [history]);

  return (
    <Box className={classes.formContainer}>
      <BoardForm
        mode="create"
        existingBoards={existingBoards}
        onSubmit={handleSubmit}
        loading={formLoading}
        onGoBack={handleGoBack}
      />
    </Box>
  );
};

export const BoardCreate = () => (
  <BoardContainer.Provider>
    <BoardCreateInner />
  </BoardContainer.Provider>
);

const useStyles = makeStyles(theme => ({
  formContainer: {
    position: 'relative',
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.background.paper,
  },
}));

export default BoardCreate;
